import HttpServices from './HttpServices';
import { ProductRequestResultProduct } from './SearchProductFeedTypes';

export default class ProductFeedConfigurationServices {
	private HttpServices: HttpServices;
	private BO_API_URL: string;

	private accountId: string;
	private halJsonHeaders;

	constructor($http, accountId) {
		this.HttpServices = new HttpServices($http);

		if (!window || !(window as any).BEYABLE_env || !(window as any).BEYABLE_env.BO_API_URL) {
			throw new Error('Configuration [window.BEYABLE_env.BO_API_URL] missing');
		} else {
			this.BO_API_URL = `${(window as any).BEYABLE_env.BO_API_URL}`;
		}

		this.accountId = accountId;
		this.halJsonHeaders = { 'Accept': 'application/hal+json' };
	}

	getDetailAndPreviewFromLinks(
		getDetailsLink: string,
		getPreviewLink: string,
		offset: number,
		limit: number,
		callbackSuccess: ((previewResult: ProductFeedPreview) => void),
		callbackError: ((error: string) => void)): void {
		this.get(getDetailsLink, data => {
			this.HttpServices.post(`${getPreviewLink}?offset=${offset}&limit=${limit}`, data, callbackSuccess, callbackError);
		}, callbackError);
	}

	getDetailAndUpdateFromLink(
		getDetailsLink: string,
		updateApplication: (config: any) => any,
		callbackSuccess: ((config: any) => void),
		callbackError: ((error: string) => void)): void {
		this.get(getDetailsLink, data => {
			const newEntity = updateApplication(data);
			this.put(getDetailsLink, newEntity, callbackSuccess, callbackError);
		}, callbackError);
	}

	getSourcePreviewFromLink(
		getPreviewLink: string,
		config: any,
		offset: number,
		limit: number,
		callbackSuccess: ((previewResult: ProductFeedPreview) => void),
		callbackError: ((error: string) => void)): void {
		this.HttpServices.post(`${getPreviewLink}?offset=${offset}&limit=${limit}`, config, callbackSuccess, callbackError);
	}


	getTransformations(callbackSuccess, callbackError) {
		this.call(`${this.BO_API_URL}feature/productfeedconfig/transformations`, 'get', null, callbackSuccess, callbackError);
	}

	getSummary(
		callbackSuccess: ((productFeedSummary: ProductFeedSummary) => void),
		callbackError: ((error: string, detail: any) => void)): void {
		this.call(`${this.BO_API_URL}feature/${this.accountId}/productfeedconfig/summary`, 'get', null, callbackSuccess, callbackError);
	}

	post(endpoint, payload, callbackSuccess, callbackError) {
		this.call(endpoint, 'post', payload, callbackSuccess, callbackError);
	}
	put(endpoint, payload, callbackSuccess, callbackError) {
		this.call(endpoint, 'put', payload, callbackSuccess, callbackError);
	}
	get(endpoint, callbackSuccess, callbackError) {
		this.call(endpoint, 'get', null, callbackSuccess, callbackError);
	}

	call(endpoint, verb, payload, callbackSuccess, callbackError) {
		if (payload) {
			this.HttpServices[verb](
				`${endpoint}`,
				payload,
				callbackSuccess,
				callbackError,
				this.halJsonHeaders
			);
		} else {
			if (verb === 'post') {
				this.HttpServices[verb](
					`${endpoint}`,
					null,
					callbackSuccess,
					callbackError,
					this.halJsonHeaders
				);
			} else {
				this.HttpServices[verb](
					`${endpoint}`,
					callbackSuccess,
					callbackError,
					this.halJsonHeaders
				);
			}
		}
	}
}

export type ProductFeedPreview = {
	totalCount: number,
	products: ProductRequestResultProduct[]
}

type Version = {
	version: string;
}
export type ProductFeedTenantConfig = {
	tenant: string;
	modelVersion?: Version;
	privateTags?: string[];
	excludedTags?: string[];
	excludedCategories?: string[];
	sources?: { [key: string]: ProductFeedSourceConfigBase };
	_links?: HalLinks;
}

enum ProductFeedSource {
	GenericUri = 'GenericUri', Http = 'Http',
	PrestaShop = 'PrestaShop', Custom = 'Custom', PrestaShopCloudSync = 'PrestaShopCloudSync', Mazeberry = 'Mazeberry', Shopify = 'Shopify',
	OnSiteData = 'OnSiteData',
	None = 'None'
}

export interface ProductFeedSourceConfigBase {
	id?: string,
	type?: ProductFeedSource,
	isActive?: boolean,
	resourceIdentifier?: string
}

type HalLinks = { [key: string]: { href: string | null, templated?: boolean } };


export type ProductFeedSummary = {
	tenantConfigs?: { [key: string]: ProductFeedTenantConfig };
	_links: HalLinks
}
